import script from "./calendarCommons.vue?vue&type=script&lang=js"
export * from "./calendarCommons.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__